import { createSlice } from "@reduxjs/toolkit";
import { logDebug } from "../../utils/logger";

const slice = createSlice({
  name: "ui",
  initialState: {
    is_blur: false,
    is_loading: false,
    is_iframe_show: true,
    is_iframe_loading: true,
    is_ad_block: false,
    header_menu_open: false,
    footer_menu_open: false,
    navigation_index: "",
    show_footer_menu: true,
    footer_menu_collapse: false,
    show_contact_dialog: false,
    contact_reason: "",
    contact_z_index: 101,
    show_login_dialog: false,
    show_register_dialog: false,
    show_forget_password_dialog: false,
    show_consent_dialog: false,
    show_newsletter_register_dialog: false,
    show_newsletter_unregister_dialog: false,
    show_billing_dialog: false,
    show_advantage_list: true,
    transfer_init: false,
    detail_transfer_init: false,
    user_init: false,
    show_transfer_delete_dialog: false,
    show_transfer_expired_delete_dialog: false,
    show_transfer_file_delete_dialog: false,
    show_transfer_share_dialog: false,
    transfer_share_mode_dialog: null,
    show_transfer_file_downloads_dialog: false,
    show_pro_floating_msg: false,
    show_background_dialog: false,
    show_preview_dialog: false,
    downloadBackground: null,
    show_transfer_password_dialog: false,
    show_transfer_customlink_dialog: false,
    show_enable_mfa_dialog: false,
    show_disable_mfa_dialog: false,
    show_login_mfa_dialog: false,
    set_show_subdomain_dialog: false,
    set_show_background_dialog: false,
    show_legal_dialog: false,
    show_privacy_dialog: false,
    session_error: false,
  },
  reducers: {
    setBlur: (state, action) => {
      state.is_blur = action.payload;
      logDebug("uiReducer", "setBlur", { is_blur: state.is_blur });
    },
    setLoading: (state, action) => {
      state.is_loading = action.payload;
      logDebug("uiReducer", "setLoading", {
        is_loading: state.is_loading,
      });
    },
    setIframeShow: (state, action) => {
      state.is_iframe_show = action.payload;
      logDebug("uiReducer", "setIframeShow", {
        is_iframe_show: state.is_iframe_show,
      });
    },
    setIframeLoading: (state, action) => {
      state.is_iframe_loading = action.payload;
      logDebug("uiReducer", "setIframeLoading", {
        is_iframe_loading: state.is_iframe_loading,
      });
    },
    setAdBlock: (state, action) => {
      state.is_ad_block = action.payload;
      logDebug("uiReducer", "setAdBlock", {
        is_ad_block: state.is_ad_block,
      });
    },
    setHeaderMenuOpen: (state, action) => {
      state.header_menu_open = action.payload;
      logDebug("uiReducer", "setHeaderMenuOpen", {
        header_menu_open: state.header_menu_open,
      });
    },
    setFooterMenuOpen: (state, action) => {
      state.footer_menu_open = action.payload;
      logDebug("uiReducer", "setFooterMenuOpen", {
        footer_menu_open: state.footer_menu_open,
      });
    },
    setNavigationIndex: (state, action) => {
      state.navigation_index = action.payload;
      logDebug("uiReducer", "setNavigationIndex", {
        navigation_index: state.navigation_index,
      });
    },
    setShowFooterMenu: (state, action) => {
      state.show_footer_menu = action.payload;
      logDebug("uiReducer", "setShowFooterMenu", {
        show_footer_menu: state.show_footer_menu,
      });
    },
    setFooterMenuCollapse: (state, action) => {
      state.footer_menu_collapse = action.payload;
      logDebug("uiReducer", "setFooterMenuCollapse", {
        footer_menu_collapse: state.footer_menu_collapse,
      });
    },
    setShowContactDialog: (state, action) => {
      state.show_contact_dialog = action.payload;
      logDebug("uiReducer", "setShowContactDialog", {
        show_contact_dialog: state.show_contact_dialog,
      });
    },
    setContactReason: (state, action) => {
      state.contact_reason = action.payload;
      logDebug("uiReducer", "setContactReason", {
        contact_reason: state.contact_reason,
      });
    },
    setContactZIndex: (state, action) => {
      state.contact_z_index = action.payload;
      logDebug("uiReducer", "setContactZIndex", {
        contact_z_index: state.contact_z_index,
      });
    },
    setShowLoginDialog: (state, action) => {
      state.show_login_dialog = action.payload;
      logDebug("uiReducer", "setShowLoginDialog", {
        show_login_dialog: state.show_login_dialog,
      });
    },
    setShowRegisterDialog: (state, action) => {
      state.show_register_dialog = action.payload;
      logDebug("uiReducer", "setShowRegisterDialog", {
        show_register_dialog: state.show_register_dialog,
      });
    },
    setShowForgetPasswordDialog: (state, action) => {
      state.show_forget_password_dialog = action.payload;
      logDebug("uiReducer", "setShowForgetPasswordDialog", {
        show_forget_password_dialog: state.show_forget_password_dialog,
      });
    },
    setShowNewsletterRegisterDialog: (state, action) => {
      state.show_newsletter_register_dialog = action.payload;
      logDebug("uiReducer", "setShowNewsletterRegisterDialog", {
        show_newsletter_register_dialog: state.show_newsletter_register_dialog,
      });
    },
    setShowNewsletterUnregisterDialog: (state, action) => {
      state.show_newsletter_unregister_dialog = action.payload;
      logDebug("uiReducer", "setShowNewsletterUnregisterDialog", {
        show_newsletter_unregister_dialog:
          state.show_newsletter_unregister_dialog,
      });
    },
    setShowBillingDialog: (state, action) => {
      state.show_billing_dialog = action.payload;
      logDebug("uiReducer", "setShowBillingDialog", {
        show_billing_dialog: state.show_billing_dialog,
      });
    },
    setShowConsentDialog: (state, action) => {
      state.show_consent_dialog = action.payload;
      logDebug("uiReducer", "setShowConsentDialog", {
        show_consent_dialog: state.show_consent_dialog,
      });
    },
    setShowAdvantageList: (state, action) => {
      state.show_advantage_list = action.payload;
      logDebug("uiReducer", "setShowAdvantageList", {
        show_advantage_list: state.show_advantage_list,
      });
    },
    setTransferInit: (state, action) => {
      state.transfer_init = action.payload;
      logDebug("uiReducer", "setTransferInit", {
        transfer_init: state.transfer_init,
      });
    },
    setTransferDetailInit: (state, action) => {
      state.detail_transfer_init = action.payload;
      logDebug("uiReducer", "setTransferDetailInit", {
        detail_transfer_init: state.detail_transfer_init,
      });
    },
    setUserInit: (state, action) => {
      state.user_init = action.payload;
      logDebug("uiReducer", "setUserInit", {
        user_init: state.user_init,
      });
    },
    setShowTransferDeleteDialog: (state, action) => {
      state.show_transfer_delete_dialog = action.payload;
      logDebug("uiReducer", "setShowTransferDeleteDialog", {
        show_transfer_delete_dialog: state.show_transfer_delete_dialog,
      });
    },
    setShowTransferExpiredDeleteDialog: (state, action) => {
      state.show_transfer_expired_delete_dialog = action.payload;
      logDebug("uiReducer", "setShowTransferExpiredDeleteDialog", {
        show_transfer_expired_delete_dialog:
          state.show_transfer_expired_delete_dialog,
      });
    },
    setShowTransferFileDeleteDialog: (state, action) => {
      state.show_transfer_file_delete_dialog = action.payload;
      logDebug("uiReducer", "setShowTransferFileDeleteDialog", {
        show_transfer_file_delete_dialog:
          state.show_transfer_file_delete_dialog,
      });
    },
    setShowTransferShareDialog: (state, action) => {
      state.show_transfer_share_dialog = action.payload;
      logDebug("uiReducer", "setShowTransferShareDialog", {
        show_transfer_share_dialog: state.show_transfer_share_dialog,
      });
    },
    setTransferShareModeDialog: (state, action) => {
      state.transfer_share_mode_dialog = action.payload;
      logDebug("uiReducer", "setTransferShareModeDialog", {
        transfer_share_mode_dialog: state.transfer_share_mode_dialog,
      });
    },
    setShowTransferFileDownloadsDialog: (state, action) => {
      state.show_transfer_file_downloads_dialog = action.payload;
      logDebug("uiReducer", "setShowTransferFileDownloadsDialog", {
        show_transfer_file_downloads_dialog:
          state.show_transfer_file_downloads_dialog,
      });
    },
    setShowProFloatingMsg: (state, action) => {
      state.show_pro_floating_msg = action.payload;
      logDebug("uiReducer", "setShowProFloatingMsg", {
        show_pro_floating_msg: state.show_pro_floating_msg,
      });
    },
    setDownloadBackground: (state, action) => {
      state.downloadBackground = action.payload;
      logDebug("uiReducer", "setDownloadBackground", {
        downloadBackground: state.downloadBackground,
      });
    },
    setShowTransferBackgroundDialog: (state, action) => {
      state.show_transfer_background_dialog = action.payload;
      logDebug("uiReducer", "setShowTransferBackgroundDialog", {
        show_transfer_background_dialog: state.show_transfer_background_dialog,
      });
    },
    setShowPreviewDialog: (state, action) => {
      state.show_preview_dialog = action.payload;
      logDebug("uiReducer", "setShowPreviewDialog", {
        show_preview_dialog: state.show_preview_dialog,
      });
    },
    setShowTransferPasswordDialog: (state, action) => {
      state.show_transfer_password_dialog = action.payload;
      logDebug("uiReducer", "setShowTransferPasswordDialog", {
        show_transfer_password_dialog: state.show_transfer_password_dialog,
      });
    },
    setShowTransferCustomlinkDialog: (state, action) => {
      state.show_transfer_customlink_dialog = action.payload;
      logDebug("uiReducer", "setShowTransferCustomlinkDialog", {
        show_transfer_customlink_dialog: state.show_transfer_customlink_dialog,
      });
    },
    setShowEnableMfaDialog: (state, action) => {
      state.show_enable_mfa_dialog = action.payload;
      logDebug("uiReducer", "setShowEnableMfaDialog", {
        show_enable_mfa_dialog: state.show_enable_mfa_dialog,
      });
    },
    setShowDisableMfaDialog: (state, action) => {
      state.show_disable_mfa_dialog = action.payload;
      logDebug("uiReducer", "setShowDisableMfaDialog", {
        show_disable_mfa_dialog: state.show_disable_mfa_dialog,
      });
    },
    setShowLoginMfaDialog: (state, action) => {
      state.show_login_mfa_dialog = action.payload;
      logDebug("uiReducer", "setShowLoginMfaDialog", {
        show_login_mfa_dialog: state.show_login_mfa_dialog,
      });
    },
    setShowSubdomainDialog: (state, action) => {
      state.set_show_subdomain_dialog = action.payload;
      logDebug("uiReducer", "setShowSubdomainDialog", {
        set_show_subdomain_dialog: state.set_show_subdomain_dialog,
      });
    },
    setShowBackgroundDialog: (state, action) => {
      state.set_show_background_dialog = action.payload;
      logDebug("uiReducer", "setShowBackgroundDialog", {
        set_show_background_dialog: state.set_show_background_dialog,
      });
    },
    setShowLegalDialog: (state, action) => {
      state.show_legal_dialog = action.payload;
      logDebug("uiReducer", "setShowLegalDialog", {
        show_legal_dialog: state.show_legal_dialog,
      });
    },
    setShowPrivacyDialog: (state, action) => {
      state.show_privacy_dialog = action.payload;
      logDebug("uiReducer", "setShowPrivacyDialog", {
        show_privacy_dialog: state.show_privacy_dialog,
      });
    },
    setSessionError: (state, action) => {
      state.session_error = action.payload;
      logDebug("uiReducer", "setSessionError", {
        session_error: state.session_error,
      });
    },
  },
});

export const {
  setBlur,
  setLoading,
  setIframeShow,
  setIframeLoading,
  setAdBlock,
  setHeaderMenuOpen,
  setFooterMenuOpen,
  setNavigationIndex,
  setShowFooterMenu,
  setFooterMenuCollapse,
  setShowContactDialog,
  setContactReason,
  setContactZIndex,
  setShowLoginDialog,
  setShowRegisterDialog,
  setShowForgetPasswordDialog,
  setShowNewsletterRegisterDialog,
  setShowNewsletterUnregisterDialog,
  setShowBillingDialog,
  setShowConsentDialog,
  setShowAdvantageList,
  setTransferInit,
  setTransferDetailInit,
  setUserInit,
  setShowTransferDeleteDialog,
  setShowTransferExpiredDeleteDialog,
  setShowTransferFileDeleteDialog,
  setShowTransferShareDialog,
  setTransferShareModeDialog,
  setShowTransferFileDownloadsDialog,
  setShowProFloatingMsg,
  setDownloadBackground,
  setShowTransferBackgroundDialog,
  setShowPreviewDialog,
  setShowTransferPasswordDialog,
  setShowTransferCustomlinkDialog,
  setShowEnableMfaDialog,
  setShowDisableMfaDialog,
  setShowLoginMfaDialog,
  setShowSubdomainDialog,
  setShowBackgroundDialog,
  setShowLegalDialog,
  setShowPrivacyDialog,
  setSessionError,
} = slice.actions;
export default slice.reducer;
